module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-photo1-de5db01a65fc765b80d4cb6384b21b3f.jpg";